import { render } from "./InfrastructureUsage.vue?vue&type=template&id=93c7ab9e&scoped=true"
import script from "./InfrastructureUsage.vue?vue&type=script&lang=js"
export * from "./InfrastructureUsage.vue?vue&type=script&lang=js"

import "./InfrastructureUsage.vue?vue&type=style&index=0&id=93c7ab9e&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93c7ab9e"]])

export default __exports__